import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

interface InfoItem {
  label: string;
  value: string;
  hint?: boolean;
}

interface RentalUnit {
  name: string;
  type: string;
  area: string;
  rentNet: string;
  additionalExpenses: string;
  heatingCosts: string;
  powerCosts: string;
  rentTotal: string;
  pricePerM2: string;
  deposit: string;
  ledger: string;
  from: string;
  until: string;
}

@Component({
  selector: 'app-real-estate',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './real-estate.component.html',
  styleUrl: './real-estate.component.scss'
})
export class RealEstateComponent {
  readonly railIcons = ['◫', '⌕', '⌂', '▤', '◒', '▧', '⌁', '▥', '🛒', '□', '⚖', '☁', '▱'];

  readonly navItems = [
    'Summary',
    'Facts',
    'Real Estate Information',
    'Rental Units',
    'Real Estate Location',
    'Real Estate Object Data'
  ];

  readonly tabs = [
    'Overview',
    'Transactions',
    'Balance',
    'Cashflow',
    'Profit and Loss',
    'Inventory card',
    'Documents',
    'Exposure',
    'Financial reports',
    'Linked investments',
    'Investment & Contracts'
  ];

  readonly infoItems: InfoItem[] = [
    { label: 'Building year', value: '2005' },
    { label: 'Property area', value: '6,000', hint: true },
    { label: 'Gross floor area', value: '28,000', hint: true },
    { label: 'Net floor area', value: '5,000', hint: true },
    { label: 'Street', value: 'Schulstr.' },
    { label: 'No.', value: '2' },
    { label: 'City', value: '8002' },
    { label: 'State', value: 'Zurich' },
    { label: 'Country', value: 'Switzerland' }
  ];

  readonly rentalUnits: RentalUnit[] = [
    {
      name: 'Bakery',
      type: 'CommercialSpace',
      area: '100.00',
      rentNet: '1,400.00',
      additionalExpenses: '200.00',
      heatingCosts: '0.00',
      powerCosts: '0.00',
      rentTotal: '1,600.00',
      pricePerM2: '14.00',
      deposit: '10,000.00',
      ledger: 'Bake4Fun',
      from: '5/1/2017',
      until: '5/1/2027'
    },
    {
      name: 'Büro',
      type: 'RentalArea',
      area: '400.00',
      rentNet: '6,000.00',
      additionalExpenses: '1,300.00',
      heatingCosts: '0.00',
      powerCosts: '0.00',
      rentTotal: '7,300.00',
      pricePerM2: '15.00',
      deposit: '20,000.00',
      ledger: 'Santis AG',
      from: '2/1/2017',
      until: '2/1/2027'
    },
    {
      name: 'Display',
      type: 'Showcase',
      area: '80.00',
      rentNet: '1,200.00',
      additionalExpenses: '0.00',
      heatingCosts: '0.00',
      powerCosts: '0.00',
      rentTotal: '1,200.00',
      pricePerM2: '15.00',
      deposit: '10,000.00',
      ledger: 'Apple',
      from: '6/1/2026',
      until: '6/30/2034'
    },
    {
      name: 'Parking',
      type: 'ParkingLot',
      area: '80.00',
      rentNet: '800.00',
      additionalExpenses: '0.00',
      heatingCosts: '0.00',
      powerCosts: '0.00',
      rentTotal: '800.00',
      pricePerM2: '10.00',
      deposit: '0.00',
      ledger: 'Santis AG',
      from: '2/1/2017',
      until: '2/1/2027'
    }
  ];
}
